import * as angular from 'angular';

class ReportParamsController {
  showParamsHeader: boolean;
  showFilterHeader: boolean;
  isParamContainerVisible: boolean;
  onToggle: any;

  toggleParamContainer() {
    this.onToggle();
  }
}

export const ID = 'reportParamsContainer';

export const reportParamsContainer: angular.IComponentOptions = {
  controller: ReportParamsController,
  controllerAs: 'ctrl',
  bindings: {
    showParamsHeader: '<',
    showFilterHeader: '<',
    isParamContainerVisible: '<',
    onToggle: '&',
  },
  template: `
  <div class="report-sub-header">
    <ul class="user-actions">
      <li class="user-action-item" ng-if="ctrl.showParamsHeader">
        <button
          class="btn btn-secondary ds toggler-button toggler-button--parameters"
          ng-class="{ 'is-active': ctrl.isParamContainerVisible }"
          ng-click="ctrl.toggleParamContainer()"
        >
          <i class="icon-parameters-horizontal"></i>
          {{ ctrl.isParamContainerVisible ? 'Hide parameters' : 'Parameters'}}
        </button>
      </li>
      <li class="user-action-item" ng-if="ctrl.showFilterHeader">
        <filter-panel-toggler is-in-report-viewer="true" />
      </li>
    </ul>
  </div>
  <div class="mode-report-header">
    <div class="run-parameters">
      <report-parameters></report-parameters>
    </div>
  </div>`,
};
